import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setting-script-result"
    }}>{`Setting Script Result`}</h1>
    <p>{`Since InDesign v18.4, you can "set result" of a UXP script. `}</p>
    <p>{`After execution, a script can return a result, which could be used for evaluating the outcome of script execution. The result can be set using `}<inlineCode parentName="p">{`script.setResult()`}</inlineCode>{` API as shown below.`}</p>
    <h2 {...{
      "id": "setting-the-result"
    }}>{`Setting the result`}</h2>
    <p>{`The following line sets the result of the UXP script being executed to the string `}<inlineCode parentName="p">{`"Hello World!"`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// called.idjs
const script = require("uxp").script;
script.setResult("Hello World!");
`}</code></pre>
    <h2 {...{
      "id": "reading-the-script-result"
    }}>{`Reading the script result`}</h2>
    <p>{`The below code snippets demonstrate how to read the script result of another script.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// caller.idjs
const myInDesign = require("indesign");
const app = myInDesign.app;
const resultOfCalledScript = app.doScript("PATH_TO_CALLED.IDJS/called.idjs", myInDesign.ScriptLanguage.UXPSCRIPT);
console.log(resultOfCalledScript);
`}</code></pre>
    <p>{`Scripts can return a result by setting the appropriate value using `}<inlineCode parentName="p">{`setResult()`}</inlineCode>{` API. This result is returned to the entity that invoked this script. If this script was executed from InDesign's scripts panel, then the result is ignored.
However, for scripts executed in InDesign Server, the result value is returned to the client that requested the script execution. If the script is forked by another script using `}<inlineCode parentName="p">{`app.doScript()`}</inlineCode>{` API the result value set by 'called' script is returned to the 'caller' script, as illustrated above.`}</p>
    <p>{`The result after executing this script on InDesign Server is shown on the client side. `}</p>
    <pre><code parentName="pre" {...{}}>{`Script result (std__string): Hello World!
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      